import GLightbox from 'glightbox';

if (document.querySelector('.CompanyMedia') !== null
|| document.querySelector('.CompanyMedia-more') !== null
) {
  const mediaItems = galleryData; //eslint-disable-line

  const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
    elements: mediaItems,
  });

  if (document.querySelector('.CompanyMedia-more') !== null) {
    const trigger = document.querySelector('.CompanyMedia-more');
    // const indexClicked = trigger.dataset.index !== undefined ? trigger.dataset.index : 0;
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      lightbox.open();
    });
  }

  const triggers = document.querySelectorAll('.jsGallery');

  for (let i = 0; i < triggers.length; i += 1) {
    triggers[i].addEventListener('click', (e) => {
      e.preventDefault();
      lightbox.openAt(parseInt(this.dataset.index)); //eslint-disable-line
    }, false);
  }
}
